import React from 'react';
import { BriefFitProvider } from './BriefPage';
import { BriefPageOne } from './BriefPageOne';
import { BriefPageTwo } from './BriefPageTwo';

/**
 * Both pages of the Partnership Brief, stacked. Each prints on its own sheet,
 * and both share one scale so type sizes always match across pages.
 */
export function PartnershipBrief() {
  return <BriefFitProvider data-id="element-828" data-mp="9izq95ae7qam">
      <div className="space-y-10" data-id="element-829" data-mp="9heu5b8fjzan">
        <BriefPageOne data-id="element-830" data-mp="3826ewbdzdag5" />
        <BriefPageTwo data-id="element-831" data-mp="382znlhwi2a0x" />
      </div>
    </BriefFitProvider>;
}